import React from 'react';
import MainApp from 'app/main';
import { createRoot } from 'react-dom/client';

const domNode = document.getElementById('app-site');
const root = createRoot(domNode);
root.render(<MainApp />);
